import React, { useState } from "react";
import {
  GroupOutlined,
  MenuBookRounded,
  CategoryOutlined,
  Accessible,
  TableRestaurant,
  MoneyOutlined,
  RestaurantMenuSharp,
  GroupWorkSharp,
  FoodBankOutlined,
  PriceChange,
  MonitorWeight,
} from "@mui/icons-material";
import "./product-config.scss";
import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";
import AddNewSpecialUser from "./special/users/add_new_user";
import { userInputs } from "../../../dashboard/formSource";
import SpecialUsersList from "./special/users/view_users_list";
import CategoryList from "./special/category/category-list";
import MenuItemList from "./special/menu/lists/menu-list";
import SectionList from "./special/section/lists/section_list";
import TablesList from "./special/tables/lists/table-list";
import ChargesList from "./special/charges/lists/charges-list";
import Specialconfig from "./retail/retailconfig/specialconfig";
import ItemList from "./retail/retailconfig/items";
import Sku from "./retail/retailconfig/sku";
import CategoryTable from "./retail/retailconfig/category";
import Section from "./retail/retailconfig/section";
import HRConfiguration from "./hr/hrConfiguration";
import Commission from "./retail/retailconfig/commission";
import UnitsDatatable from "../../components/datatable/unitsDataTable";
import UnitsConversionDatatable from "../../components/datatable/unitsConversionDataTable";
import IngredientsDatatable from "../../components/datatable/ingredientsDataTable";
import RecipesDatatable from "../../components/datatable/recipesDataTable";
import RecipesAndMenuDatatable from "../../components/datatable/recipesMenuDataTable";
import VendorsDatatable from "../../components/datatable/vendorsDataTable";

const productMapping = {
  "Basic POS": [
    {
      icon: <GroupOutlined />,
      label: "User Updation",
      content: (
        <div style={{ height: "100vh", overflow: "auto" }}>
          <>
            <AddNewSpecialUser inputs={userInputs} />
            <SpecialUsersList />
          </>
        </div>
      ),
    },
    {
      icon: <CategoryOutlined />,
      label: "Category Updation",
      content: <CategoryList />,
    },
    {
      icon: <MenuBookRounded />,
      label: "Menu Updation",
      content: <MenuItemList />,
    },
    {
      icon: <Accessible />,
      label: "Section Updation",
      content: <SectionList />,
    },
    {
      icon: <TableRestaurant />,
      label: "Tables Updation",
      content: <TablesList />,
    },
    {
      icon: <MoneyOutlined />,
      label: "Extra Charges Updation",
      content: <ChargesList />,
    },
  ],
  "Special Billing": [
    {
      icon: <GroupOutlined />,
      label: "User Updation",
      content: (
        <div style={{ height: "100vh", overflow: "auto" }}>
          <>
            <AddNewSpecialUser inputs={userInputs} />
            <SpecialUsersList />
          </>
        </div>
      ),
    },
    {
      icon: <CategoryOutlined />,
      label: "Category Updation",
      content: <CategoryList />,
    },
    {
      icon: <MenuBookRounded />,
      label: "Menu Updation",
      content: <MenuItemList />,
    },
    {
      icon: <Accessible />,
      label: "Section Updation",
      content: <SectionList />,
    },
    {
      icon: <TableRestaurant />,
      label: "Tables Updation",
      content: <TablesList />,
    },
    {
      icon: <MoneyOutlined />,
      label: "Extra Charges Updation",
      content: <ChargesList />,
    },
  ],
  "Lite Billing": [
    {
      icon: <GroupOutlined />,
      label: "User Updation",
      content: (
        <div style={{ height: "100vh", overflow: "auto" }}>
          <>
            <AddNewSpecialUser inputs={userInputs} />
            <SpecialUsersList />
          </>
        </div>
      ),
    },
    {
      icon: <CategoryOutlined />,
      label: "Category Updation",
      content: <CategoryList />,
    },
    {
      icon: <MenuBookRounded />,
      label: "Menu Updation",
      content: <MenuItemList />,
    },
    {
      icon: <Accessible />,
      label: "Section Updation",
      content: <SectionList />,
    },
    {
      icon: <TableRestaurant />,
      label: "Tables Updation",
      content: <TablesList />,
    },
    {
      icon: <MoneyOutlined />,
      label: "Extra Charges Updation",
      content: <ChargesList />,
    },
  ],
  PMS: [
    {
      icon: <GroupOutlined />,
      label: "User Updation",
      content: (
        <div style={{ height: "100vh", overflow: "auto" }}>
          <>
            <AddNewSpecialUser inputs={userInputs} />
            <SpecialUsersList />
          </>
        </div>
      ),
    },
  ],
  "Advanced Inventory": [
    {
      icon: <GroupOutlined />,
      label: "User Management",
      content: (
        <div style={{ height: "100vh", overflow: "auto" }}>
          <>
            <AddNewSpecialUser inputs={userInputs} />
            <SpecialUsersList />
          </>
        </div>
      ),
    },
    {
      icon: <GroupOutlined />,
      label: "Vendor Addition",
      content: <VendorsDatatable />,
    },
    {
      icon: <MonitorWeight />,
      label: "Unit Updation",
      content: <UnitsDatatable />,
    },
    {
      icon: <PriceChange />,
      label: "Unit Conversions",
      content: <UnitsConversionDatatable />,
    },
    {
      icon: <FoodBankOutlined />,
      label: "Ingredients management",
      content: <IngredientsDatatable />,
    },
    {
      icon: <GroupWorkSharp />,
      label: "Recipe Management",
      content: <RecipesDatatable />,
    },
    {
      icon: <RestaurantMenuSharp />,
      label: "Menu Management",
      content: <RecipesAndMenuDatatable />,
    },
  ],
  Retail: [
    {
      icon: <GroupOutlined />,
      label: "User Updation",
      content: (
        <div style={{ height: "100vh", overflow: "auto" }}>
          <>
            <AddNewSpecialUser inputs={userInputs} />
            <SpecialUsersList />
          </>
        </div>
      ),
    },
    {
      icon: <GroupOutlined />,
      label: "Section Updation",
      content: <Section />,
    },
    {
      icon: <CategoryOutlined />,
      label: "Category Updation",
      content: <CategoryTable />,
    },
    { icon: <GroupOutlined />, label: "Sku Updation", content: <Sku /> },
    {
      icon: <MenuBookRounded />,
      label: "Items Updation",
      content: <ItemList />,
    },
    {
      icon: <GroupOutlined />,
      label: "Special configuration",
      content: <Specialconfig />,
    },
    {
      icon: <GroupOutlined />,
      label: "Commission",
      content: <Commission />,
    },
  ],
  HR: [
    {
      icon: <GroupOutlined />,
      label: "User Updation",
      content: (
        <div style={{ height: "100vh", overflow: "auto" }}>
          <>
            <AddNewSpecialUser inputs={userInputs} />
            <SpecialUsersList />
          </>
        </div>
      ),
    },
    {
      icon: <GroupOutlined />,
      label: "HR Configuration",
      content: <HRConfiguration />,
    },
  ],
};

const ProductConfigComponent = () => {
  const [selectedTab, setSelectedTab] = useState(0);

  const handleTabSelect = (index) => {
    setSelectedTab(index);
  };
  const getProductItem = sessionStorage.getItem("configurePath");


  const config = getProductItem?.split("/")[1];
  console.log(config);
  const productTabs = productMapping[config] || [];

  return (
    <div className="list">
      <Sidebar />
      <div className="listContainer">
        <Navbar />
        <div className="tabs-container">
          <div className="tab-list">
            {productTabs.map((tab, index) => (
              <div
                key={index}
                className={`tab-item ${selectedTab === index ? "selected" : ""
                  }`}
                onClick={() => handleTabSelect(index)}
              >
                {tab.icon}
                <div>{tab.label}</div>
              </div>
            ))}
          </div>

          <div className="tab-panels">
            {productTabs.map((tab, index) => (
              <div
                key={index}
                className={`tab-panel ${selectedTab === index ? "selected" : ""
                  }`}
              >
                {selectedTab === index && <div>{tab.content}</div>}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductConfigComponent;
